import React from 'react';
import './AffirmationCard.css';

const AffirmationCard = ({ affirmation, userName }) => {
  return (
    <div className="affirmation-card">
      <div className="card-glow"></div>
      <p className="affirmation-text">
        {userName && <span className="user-name">{userName}, </span>}
        {affirmation}
      </p>
    </div>
  );
};

export default AffirmationCard;
